import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const fetchFingerPrintVisitorId = async () => {
  const fpPromise = FingerprintJS.load();
  const fp = await fpPromise;
  const result = await fp.get();
  // console.log('visitorid:', result.visitorId);
  return result.visitorId;
};
